module.exports = __webpack_public_path__ + "static/img/logo-icon.ee54c4e7.png";